import React from 'react'

import { Client, TClientForm } from '../../types'
import { parseClientToForm } from '../../lib/parsers'
import ClientForm, { SavedClientSnapshot } from './form'
import InvoiceOverlayModal from '../modals'
import { ButtonVariant } from '../ui/button'

export type ClientModalProps = {
  open: boolean
  onClose: () => void
  mode: 'create' | 'edit'
  client?: Client
  createDefaultValues?: TClientForm
  saveAndSendLabel?: string
  saveAndSendDisabled?: boolean
  onSave: (clientId?: string, savedClient?: SavedClientSnapshot) => void | Promise<void>
  onSaveAndSend?: (clientId?: string, clientEmail?: string) => void | Promise<void>
}

const ClientModal: React.FC<ClientModalProps> = ({
  open,
  onClose,
  mode,
  client,
  createDefaultValues,
  saveAndSendLabel,
  saveAndSendDisabled = false,
  onSave,
  onSaveAndSend,
}) => {
  if (!open) return null
  if (mode === 'edit' && !client) return null

  const title = 'Client'
  const description = 'Details of the business or person you are sending the invoice to.'

  return (
    <InvoiceOverlayModal open={open} onClose={onClose} title={title} description={description}>
      {mode === 'create' ? (
        <ClientForm
          key='create-client'
          defaultValues={createDefaultValues}
          onSave={onSave}
          onCancel={onClose}
          saveLabel='Save client'
          cancelLabel='Close'
          collapseOptionalFields
        />
      ) : (
        <ClientForm
          key={String(client!._id)}
          defaultValues={parseClientToForm(client!)}
          initialFocus='email'
          silent
          saveLabel='Save'
          saveVariant={ButtonVariant.LIGHT}
          saveAndSendLabel={saveAndSendLabel}
          saveAndSendDisabled={saveAndSendDisabled}
          onSave={onSave}
          onSaveAndSend={onSaveAndSend}
          onCancel={onClose}
          cancelLabel='Close'
          collapseOptionalFields
        />
      )}
    </InvoiceOverlayModal>
  )
}

export default ClientModal
